import { ReactElement, useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ImportGetResponse, ImportService } from "../../services/ImportService";
import { BodyContainer } from "./AuthSite";
import { TranslationService } from "../../services/TranslationService";
import FileService from "../../services/FileService";

export enum Controls {
  newinvoices,
  newCustomers,
  newPayments,
  DebtIncrement,
  DebtDecrement
}

function ImportFinish(): ReactElement {
  const { translate, currentLanguage } = TranslationService;
  const [itemResult, setItemResult] = useState<ImportGetResponse['item']>();
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const id = params.get("id") || "";

  const handleDownloadReport = useCallback(
    async () => {
      if (itemResult?.ImportID) {
        const file = await ImportService.getFile(itemResult.ImportID.toString());
        FileService.download(file)
      }
      return;
    },
    [itemResult?.ImportID]
  );

  const control = useMemo(
    () =>
      (itemResult?.ControlResult) ?
        JSON.parse(itemResult.ControlResult)[0] :
        null
    ,
    [itemResult?.ControlResult]
  )

  const returnHome = useCallback(
    () =>
      history.replace(`/${currentLanguage}/company`)
    ,
    [currentLanguage, history]
  )

  const finishImport = useCallback(
    async () => {
      await ImportService.importFinish(id);
      returnHome()
    },
    [id, returnHome]
  )

  const getLine = useMemo(() => {
    if (control) {
      switch (control.control) {
        case Controls.DebtDecrement:
          return translate.DebtDecrement + ". " + translate.RefVal + ": " + control.reference + ": " + translate.CurrentImport + + ": " + control.value.toString() + "%";
        case Controls.DebtIncrement:
          return translate.DebtIncrement + ". " + translate.RefVal + ": " + control.reference + ": " + translate.CurrentImport + + ": " + control.value.toString() + "%";
        case Controls.newCustomers:
          return translate.newCustomers + ". " + translate.RefVal + ": " + control.reference + ". " + translate.CurrentImport + + ": " + control.value.toString();
        case Controls.newinvoices:
          return translate.newinvoices + ". " + translate.RefVal + ": " + control.reference + ". " + translate.CurrentImport + + ": " + control.value.toString();
        case Controls.newPayments:
          return translate.newPayments + ". " + translate.RefVal + ": " + control.reference + ". " + translate.CurrentImport + + ": " + control.value.toString();
        default:
          return null;
      }

    }
  }, [control, translate.CurrentImport, translate.DebtDecrement, translate.DebtIncrement, translate.RefVal, translate.newCustomers, translate.newPayments, translate.newinvoices])

  useEffect(() => {
    const ImportControlResult = async () => {
      const result = await ImportService.get(id);
      if (result instanceof Error) {
        returnHome()
        return;
      }
      if (result.Response === 'Ok') {
        setItemResult(result.item as any)
        return;
      }
    }
    id && ImportControlResult();
  }, [id, returnHome])

  return (
    <div className="old-page">
      <BodyContainer>
        <div className="pt-5">
          <div className="container" id="signin">
            <div className="d-flex flex-column fw-normal fs-7 gap-3">
              <h3>{translate.SuspendendImport}</h3>
              <p>{translate.ProcessImportSuspended}</p>
              {control && <span className="text-danger">{getLine}</span>}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a onClick={handleDownloadReport} className="pointer ellipsis-oneline d-inline">
                <i className="fas fa-fw fa-download" /> {TranslationService.translate.DownloadFile.toUpperCase()}
              </a>
            </div>
            <div className="d-flex align-items-center mt-3 gap-3">
              <button type="button" className="btn btn-primary py-1 "
                onClick={finishImport}>{TranslationService.translate.FinishImport}</button>

              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a onClick={returnHome} className="pointer ellipsis-oneline d-inline">
                {TranslationService.translate.Cancel}
              </a>
            </div>
          </div>
        </div>
      </BodyContainer>
    </div>
  );
}

export default ImportFinish;
